import PropsTypes from 'prop-types';
import React from 'react';

function Modal({ title, content, setStore, show }) {
  function hideModal() {
    setStore({ show: 'none' });
  }

  return (
    <div id="myModal" className="modal" style={{ display: show }}>
      <div className="modal-header">
        <h2 className="modal-title">{title}</h2>
        <span className="close" onClick={hideModal}>
          &times;
        </span>
      </div>
      <div className="modal-content">
        <div className="content">{content}</div>
      </div>
    </div>
  );
}

Modal.defaultPropType = {
  show: 'none',
  content: <></>,
};

Modal.propTypes = {
  title: PropsTypes.node,
  content: PropsTypes.node,
  show: PropsTypes.oneOf(['none', 'block']),
  setStore: PropsTypes.func.isRequired,
};

export default Modal;
